"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _logoLeanlancer = _interopRequireDefault(require("../assets/img/logo-leanlancer.png"));

var _components = require("../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      height: 64,
      boxShadow: 'none',
      borderBottom: "1px solid ".concat(theme.palette.primary.light)
    },
    languageContainer: {
      margin: theme.spacing(0, 2)
    },
    logoImg: {
      height: 32,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    languageSwitcher: {
      color: theme.palette.primary.contrastText,
      '& svg': {
        fill: theme.palette.primary.contrastText
      }
    }
  };
});
var CustomLanguageInput = (0, _core.withStyles)(function (theme) {
  return {
    input: {
      backgroundColor: theme.palette.primary.main,
      border: '1px solid #ced4da',
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 4,
        borderColor: theme.palette.secondary.light
      }
    }
  };
})(_core.InputBase);

var Topbar = function Topbar(_ref) {
  var className = _ref.className,
      children = _ref.children,
      lang = _ref.lang,
      onLangChange = _ref.onLangChange,
      homeHref = _ref.homeHref,
      rest = _objectWithoutProperties(_ref, ["className", "children", "lang", "onLangChange", "homeHref"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, _extends({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    color: "primary",
    position: "fixed"
  }), /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, homeHref ? /*#__PURE__*/_react.default.createElement("a", {
    href: homeHref
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Logo",
    src: _logoLeanlancer.default,
    className: classes.logoImg
  })) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Logo",
    src: _logoLeanlancer.default,
    className: classes.logoImg
  })), children, onLangChange && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.languageContainer
  }, /*#__PURE__*/_react.default.createElement(_components.LanguageSwitcher, {
    lang: lang,
    onChange: onLangChange,
    className: classes.languageSwitcher,
    input: /*#__PURE__*/_react.default.createElement(CustomLanguageInput, null)
  }))));
};

Topbar.propTypes = {
  className: _propTypes.default.string
};
var _default = Topbar;
exports.default = _default;